import { ApiClient } from '@smarton-pbx/shared';
import { language } from './i18n';

/**
 * Same-origin API client: every tenant's hostname serves its own API at /api.
 * It tells the server the language the page shows, so its messages match.
 */
export const api = new ApiClient('', (input, init) => fetch(input, { ...init, headers: { ...(init?.headers as Record<string, string>), 'X-Language': language } }));

/** A person's photo, for Avatar; null when they have none (their initials show). */
export const photoUrl = (userId: string, version: string | null) => (version ? api.photoUrl(userId, version) : null);
